import React, { Component } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import DeleteIcon from '@material-ui/icons/Delete';
import IconButton from '@material-ui/core/IconButton';

import CardMedia from "@material-ui/core/CardMedia";
import Modal from "@material-ui/core/Modal";
import Paper from "@material-ui/core/Paper";
import Loading from '../Loading/Loading';
import Resizer from 'react-image-file-resizer';
import 'react-dropzone-uploader/dist/styles.css'
import Dropzone from 'react-dropzone-uploader'

  

  
const config = {
    bucketName: 'solanas',
    dirName: 'img', /* optional */
    region: 'sa-east-1',
    accessKeyId: 'AKIAIDJS7XGVXOZCKMVQ',
    secretAccessKey: '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'
}

class UploadPhoto extends Component {
    
    constructor(props)
    {
        super(props);
        this.state = {
            currentFile: null,
            activeLoading: false
        }
        this.uploadButtonRef = React.createRef();
    }

	componentDidMount() {
		this.state = {
		};
    }

    getUploadParams =  ({meta}) => {return { 
            fields:
            {
                AWSAccessKeyId:"AKIAIDJS7XGVXOZCKMVQ",
                acl:"public-read",
                key:"",
                policy:"",
                signature:"FDPVZztuG35hQgWU0q9ZJgmMjAkl9uypcmji9P9d"
            },
            url: "https://solanas.s3-sa-east-1.amazonaws.com/", 
            meta: {}
      }}
    

    onInputChange = (e) => {

        Resizer.imageFileResizer(
            e.target.files[0],
            300,
            300,
            'JPEG',
            70,
            0,
            uri => {
                const thumnailFile = new File([uri], 'thumbnail.jpg', { type: 'image/jpeg' })
                this.setState({currentThumbnail: thumnailFile});
                this.uploadButtonRef.current.disabled = !uri != '';
    
            },
            'blob',
            200,
            200,
        );

        Resizer.imageFileResizer(
            e.target.files[0],
            1280,
            1280,
            'JPEG',
            100,
            0,
            uri => {
                const imageFile = new File([uri], 'thumbnail.jpg', { type: 'image/jpeg' })
                this.setState({currentFile: imageFile});
                this.uploadButtonRef.current.disabled = !uri != '';
    
            },
            'blob',
            200,
            200,
        );

        


    }

      // called every time a file's `status` changes
     handleChangeStatus = ({ meta, file }, status) => { console.log(status, meta, file) }
        
        // receives array of files that are done uploading when submit button is clicked
     handleSubmit = (files, allFiles) => {
            console.log(files.map(f => f.meta))
            allFiles.forEach(f => f.remove())
        }


    upload = (e) => {
        e.preventDefault();
        this.setState({activeLoading:true});
        
    }


	render() {
		return (
			<React.Fragment>
				<div  style={{ width: '500px', display:'inline'}}>
                <Dropzone
                getUploadParams={this.getUploadParams}
                onChangeStatus={this.handleChangeStatus}
                onSubmit={this.handleSubmit}
                accept="image/*"
                />
                            </div>
				</React.Fragment>
		);
	}
}
export default UploadPhoto;
